import invariant from 'invariant';
import type { Project } from '@frameio/graphql-client/generated';
// @todo (WEB-1045): Add condensed UUID support to routes
// import { toCondensedUUID } from '@frameio/utils/formatters/uuid';
import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

// @todo (WEB-1045): Remove when condensed UUID support is added to routes
const toCondensedUUID = (uuid: string): string => uuid;

/**
 * AllSharesPage
 *
 * /project/:projectId/shares
 */
type AllSharesPage = {
  page: 'allShares';
  projectId: Project['id'];
};

export type AllSharesGetLinkParams = AllSharesPage;

export const getLinkForAllShares = (
  params: AllSharesGetLinkParams
): ValidHref => {
  // Assert required params for better error messages
  invariant(params.projectId, 'projectId is required');
  const projectId = toCondensedUUID(params.projectId);

  if (params.page === 'allShares') {
    return createUrl({
      pathname: `/project/${projectId}/shares`,
    });
  }

  throw new Error('Not implemented');
};

export const isAllSharesPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  // /project/:projectId/shares
  return parts[1] === 'project' && parts[3] === 'shares';
};
